import React from 'react';
import { View } from 'react-native';

import Zzz from '@assets/icons/zzz.svg';

import { scale } from '@components/frame';
import { ncFileStatuses } from '@helpers';
import Svg from '@styles/icons/svg';

export default ({ status, ncFile, C, selected }) => {
  const selectIcon = () => {
    const iconHeight = scale(12);
    const iconWidth = scale(14);

    if (!ncFile) {
      return <View />;
    }
    switch (status) {
      case 'muted':
        return <Zzz height={iconHeight} width={iconWidth} />;
      case ncFileStatuses.PartiallyLinked:
        return <Svg icon="machineLinkSmall" height={iconHeight} width={iconWidth} color="Chart/Light/Warning" />;
      case ncFileStatuses.Ignored:
        return <Svg icon="machineIgnoredSmall" height={scale(12)} width={scale(12)} color={selected ? 'Label/Light/AlwaysLight Secondary' : 'Label/Light/Tertiary'} />;
      case ncFileStatuses.Setup:
        return <Svg icon="setup" height={scale(12)} width={scale(12)} color={selected ? 'Label/Light/AlwaysLight Secondary' : 'Status/Light/Setup'} />;
      case ncFileStatuses.Unknown:
        return (
          <View style={{ width: scale(10), height: scale(10), justifyContent: 'center', alignItems: 'center' }}>
            <View style={{ width: scale(4), height: scale(4), borderRadius: scale(4), backgroundColor: C('Status/Light/Missing') }} />
          </View>
        );
      default:
        return null;
    }
  };

  return selectIcon();
};
